// extracted by mini-css-extract-plugin
export default {"menuItems":"Menu_menuItems__MQetf","menuItem":"Menu_menuItem__jFi0K"};